import Repository from './Repository';
const LOGIN = '/user/login';
const SSO = '/user/check';
export default {
  login(payload) {
    return Repository.post(`${LOGIN}`, payload);
  },
  loginSSO(payload) {
    return Repository.post(`${SSO}`, payload);
  }
};
